import { useMemo } from 'react';
import { useSessionOrThrow } from './use-session';

function useNavLink({ to, isExternal }: { to?: string; isExternal: boolean }) {
    const { complianceSystemUrl, complianceAgencyId } = useSessionOrThrow();

    const href = useMemo(() => {
        if (to === undefined) return to;
        if (isExternal) {
            const url = new URL(`${complianceSystemUrl}${to}`);

            url.searchParams.set('__acp_agency_id', complianceAgencyId.toString());

            return url.toString();
        }

        return to;
    }, [to, isExternal, complianceSystemUrl, complianceAgencyId]);

    return href;
}

export { useNavLink };
